import { PluginKey } from '@tiptap/pm/state'
import type { EditorView } from '@tiptap/pm/view'

export class TiptapSuggestionsConfig {
  readonly name: string
  readonly character: string
  readonly nodeTag: string
  readonly supportedNavigationKeys: string[]

  readonly pluginKey

  constructor(config: {
    name: string
    character: string
    nodeTag: string
    supportedNavigationKeys: ['ArrowUp', 'ArrowDown', 'Enter']
  }) {
    this.name = config.name
    this.character = config.character
    this.nodeTag = config.nodeTag

    // Optionals
    this.supportedNavigationKeys = config.supportedNavigationKeys

    // Generated
    this.pluginKey = new PluginKey(this.name)
  }

  suggestionsState(viewState: EditorView['state']) {
    return this.pluginKey.getState(viewState)
  }
}
